@if (call.videoUrl !== null) {
  <app-video-player [call]="call" (jumpToNextSpeaker)="jumpToNextSpeaker($event)" (updateMediaTime)="updateMediaTimeQueryParameter()"></app-video-player>
} @else if (call.audioUrl !== null) {
  <app-audio-player [call]="call" (jumpToNextSpeaker)="jumpToNextSpeaker($event)" (updateMediaTime)="updateMediaTimeQueryParameter()"></app-audio-player>
}
